// extracted by mini-css-extract-plugin
module.exports = {"infoBlockRow":"info-block-row-efb","infoBlockRowTitle":"info-block-row__title-047","infoBlockRowContent":"info-block-row__content-e5b"};